// unitMixin.js
import { getUnitList } from "@/api/modules/system-management/unit-management.js";

export const productQuantityIsRoundedMixin = {
    data() {
        return {
            unitList: []
        };
    },
    methods: {
        getUnitList() {
            getUnitList().then(res=>{
                if(res.code==0){
                    this.unitList=res.data.records;
                }
            });
        },
        getUnitisRounded(unitName){
            let unitPro= this.unitList.find(x=>x.unitName==unitName);             
            if(!unitPro){
                return 0;
            }
            return unitPro.isRounded==0?2:0;
        },
        getUnitisByUuidRounded(unitUuid){
            let unitPro= this.unitList.find(x=>x.unitUuid==unitUuid);             
            if(!unitPro){
                return 0;
            }
            return unitPro.isRounded==0?2:0;
        }
    },
    mounted() {
        this.getUnitList();
    }
};